import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { urlDaImagem } from '../Destaque/View';

/**
 * Citação ou depoimento, no molde dos folders:
 *
 *  - painel: fundo azul com a padronagem da marca, aspas amarelas e texto
 *    branco grande (depoimento, a fala principal);
 *  - cartao: fundo branco com a barra e as aspas na cor escolhida (fala no
 *    meio do texto).
 *
 * Os dois ficam na coluna do texto (na notícia, não passam por cima do "Veja
 * também"). A fala vai em <blockquote> e quem fala em <figcaption>, dentro de
 * um <figure>; as aspas grandes são desenho (aria-hidden).
 */

export const CORES = {
  verde: '#1f6b2d',
  azul: '#0055a1',
  vermelho: '#c8161d',
};

// Um parágrafo por linha em branco; quebra simples vira espaço.
export const paragrafos = (texto) =>
  (texto || '')
    .split(/\n\s*\n/)
    .map((p) => p.replace(/\s*\n\s*/g, ' ').trim())
    .filter(Boolean);

const CitacaoView = ({ data = {}, vazio }) => {
  const partes = paragrafos(data.texto);
  if (!partes.length) return vazio || null;
  const composicao = data.composicao === 'painel' ? 'painel' : 'cartao';
  const cor = CORES[data.cor] ? data.cor : 'verde';
  const nome = (data.nome || '').trim();
  const cargo = (data.cargo || '').trim();
  const foto = urlDaImagem(data.foto, 'thumb');
  const link = (data.link || '').trim();

  return (
    <figure
      className={`ag-citacao ag-citacao--${composicao}`}
      style={
        composicao === 'cartao' ? { '--ag-citacao-cor': CORES[cor] } : undefined
      }
    >
      <div className="ag-citacao__inner">
        <blockquote className="ag-citacao__fala">
          <span className="ag-citacao__aspas" aria-hidden="true">
            “
          </span>
          <div className="ag-citacao__texto">
            {partes.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </blockquote>
        {(nome || cargo) && (
          <figcaption className="ag-citacao__autor">
            {foto && <img className="ag-citacao__foto" src={foto} alt="" />}
            <span>
              {nome && <strong className="ag-citacao__nome">{nome}</strong>}
              {cargo && <span className="ag-citacao__cargo">{cargo}</span>}
            </span>
          </figcaption>
        )}
        {link && (
          <UniversalLink
            className="ag-citacao__fonte"
            href={flattenToAppURL(link)}
          >
            {(data.textoLink || '').trim() || 'Fonte'}
          </UniversalLink>
        )}
      </div>
    </figure>
  );
};

CitacaoView.propTypes = {
  data: PropTypes.shape({
    composicao: PropTypes.string,
    cor: PropTypes.string,
    texto: PropTypes.string,
    nome: PropTypes.string,
    cargo: PropTypes.string,
    foto: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.string,
    ]),
    link: PropTypes.string,
    textoLink: PropTypes.string,
  }),
  vazio: PropTypes.node,
};

export default CitacaoView;
